import {Component, ElementRef, HostListener, OnInit} from '@angular/core';

@Component({
  selector: 'awair-dropdown-wrapper',
  templateUrl: './dropdown-wrapper.component.html',
  styleUrls: ['./dropdown-wrapper.component.scss']
})

export class DropdownWrapperComponent implements OnInit {

  @HostListener('document:click', ['$event']) documentClick(event: MouseEvent) {
    this.onDropdownEvent(event, this.el.nativeElement);
  }

  width: number = 0;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
  }

  onDropdownEvent(event: MouseEvent, dropdownContainer: HTMLElement): void {
    const dropdownEl: HTMLElement = dropdownContainer.querySelector('ul');

    if (!(dropdownContainer.contains(event.target as HTMLElement)) && dropdownEl) {
      // If selected element is not dropdown element,
      dropdownEl.style.display = 'none';

    } else if (dropdownEl) {
      // If selected element is dropdown element, make it toggle
      // On init, element's display is set to ''
      dropdownEl.style.display = dropdownEl.style.display === 'none' || dropdownEl.style.display === '' ? 'block' : 'none';
    }
  }
}
